/* eslint react/prefer-stateless-function: 0 */

import React from 'react';
import PropTypes from 'prop-types';
import {
  Text,
  View,
  ActivityIndicator,
  ScrollView,
} from 'react-native';
import { Button } from 'react-native-elements';
import ReactRouterPropTypes from 'react-router-prop-types';
import { matchPath } from 'react-router-dom';
import Autolink from 'react-native-autolink';
import QRCode from 'react-native-qrcode-svg';
import { graphql } from '@apollo/client/react/hoc';
import { compose } from 'ramda';

import { AppSyncClientUnauthenticated } from '../../backends/AppSyncClient';
import GetApp from '../../q/GetApp';
import App from '../../modules/data/App';
import styles from '../../styles';
import { translate } from '../../locales/i18n';

import logo from '../../assets/icons/favicon.png';

class PublisherAppApproved extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.getDataURL = this.getDataURL.bind(this);
    this.callback = this.callback.bind(this);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'PublisherAppApproved';

    this.state = {
      qrData: '',
    };
  }

  componentDidMount() {
    this.getDataURL(); // => Calling this in here to make sure the QRCode component did mount
  }

  getDataURL() {
    if (this.svg !== undefined && this.svg.toDataURL !== undefined) {
      console.log(this.svg);
      this.svg.toDataURL(this.callback);
    }
  }

  callback(dataURL) {
    this.setState({ qrData: dataURL });
  }

  render() {
    const { history, app } = this.props;
    const { qrData } = this.state;

    if (!app) {
      return (
        <View
          style={{
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <ActivityIndicator size="large" color={styles.primaryColor} />
        </View>
      );
    }
    console.log('app');
    console.log(app);

    return (
      <ScrollView
        style={styles.view.headless}
      >
        <Text
          style={{
            fontFamily: styles.primaryFont700,
            fontSize: 32,
            fontWeight: '700',
            alignSelf: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            paddingBottom: 52,
            paddingHorizontal: 20,
          }}
        >
          {translate('approved_title')}
        </Text>
        {/* <Text
          style={{
            fontFamily: styles.primaryFont400,
            fontSize: 14,
            fontWeight: '400',
            alignSelf: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            paddingVertical: 32,
            paddingHorizontal: 20,
          }}
        >
          {translate('approved_comment')}
        </Text> */}
        <Text
          style={{
            fontFamily: styles.primaryFont400,
            fontSize: 14,
            fontWeight: '400',
            alignSelf: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            paddingHorizontal: 20,
          }}
        >
          {translate('approved_link')}
        </Text>
        <Autolink
          truncate={0}
          style={{
            alignSelf: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            paddingHorizontal: 20,
          }}
          text={`https://aionrails.com/ai-agent/${app.data.uuid}`}
          textProps={{ selectable: true }}
        />
        <Text
          style={{
            fontFamily: styles.primaryFont400,
            fontSize: 14,
            fontWeight: '400',
            alignSelf: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            paddingHorizontal: 20,
            paddingTop: 32,
            paddingBottom: 10,
          }}
        >
          {translate('approved_qr')}
        </Text>
        <View
          style={{
            alignSelf: 'center',
            justifyContent: 'center',
            paddingHorizontal: 20,
            paddingBottom: 32,
          }}
        >
          <QRCode
            size={128}
            value={`https://aionrails.com/ai-agent/${app.data.uuid}`}
            logo={logo}
            logoSize={32}
            getRef={(c) => { this.svg = c; }}
            onPress={() => {
              if (qrData.length !== 0) {
                Print.printAsync({
                  html: `
                     <h3>Online self-guided app:</h3>
                     <img src="${qrData}"/>
                     <img src="data:image/png;base64,${qrData}"/>
                   `,
                });
              }
            }}
          />
        </View>

        <Autolink
          truncate={0}
          style={{
            fontFamily: styles.primaryFont400,
            fontSize: 14,
            fontWeight: '400',
            alignSelf: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            paddingHorizontal: 20,
            paddingTop: 32,
          }}
          text={translate('approved_app', { url: 'https://buy.stripe.com/fZe01UbID0DtbAYaEE' })}
          textProps={{ selectable: true }}
        />

        <View style={[styles.form.containerButtons, { marginBottom: 20 }]}>
          <Button
            title={translate('button_edit')}
            containerStyle={{
              marginTop: 40,
              alignSelf: 'center',
            }}
            buttonStyle={styles.button.secondary}
            // disabledStyle={styles.button.secondaryDisabled}
            titleStyle={styles.button.secondaryTitle}
            // disabledTitleStyle={styles.button.secondaryTitleDisabled}
            onPress={() => {
              history.push(`/editapp/${app.data.origin}`);
            }}
          />
          <Button
            title={translate('button_test')}
            containerStyle={{
              marginTop: 40,
              alignSelf: 'center',
            }}
            buttonStyle={styles.button.secondary}
            // disabledStyle={styles.button.secondaryDisabled}
            titleStyle={styles.button.secondaryTitle}
            // disabledTitleStyle={styles.button.secondaryTitleDisabled}
            onPress={() => {
              history.push(`/ai-agent/${app.data.uuid}`);
            }}
          />
          <Button
            title={translate('menu_my_apps')}
            containerStyle={{
              marginTop: 40,
              alignSelf: 'center',
            }}
            buttonStyle={styles.button.primary}
            // disabledStyle={styles.button.primaryDisabled}
            titleStyle={styles.button.primaryTitle}
            // disabledTitleStyle={styles.button.primaryTitleDisabled}
            onPress={() => {
              history.push('/my-ai-agents');
            }}
          />
        </View>
      </ScrollView>
    );
  }
}
PublisherAppApproved.defaultProps = {
  app: null,
};

PublisherAppApproved.propTypes = {
  app: PropTypes.instanceOf(App),
  history: ReactRouterPropTypes.history.isRequired,
};

export default compose(
  graphql(GetApp, {
    props: (props) => {
      console.log('graphql props');
      console.log(props);
      if (!props.data.getApps) {
        return {};
      }
      const app = App.createFromData(props.data.getApps);
      if (app && app.data && app.data.endpoints === undefined) {
        app.data.endpoints = [];
      }
      return {
        app,
      };
    },
    options: (props) => {
      const { location } = props;
      const match = matchPath('/approved/:id', location.pathname);
      const uuid = match ? match.params.id : undefined;

      return {
        variables: {
          uuid,
        },
        client: AppSyncClientUnauthenticated,
        // fetchPolicy: 'no-cache',
        fetchPolicy: 'cache-and-network',
        // fetchPolicy: 'network-only',
      };
    },
    client: AppSyncClientUnauthenticated,
  })
)(PublisherAppApproved);
